import { render, staticRenderFns } from "./TableNotesButton.vue?vue&type=template&id=79913a76&scoped=true"
import script from "./TableNotesButton.vue?vue&type=script&lang=js"
export * from "./TableNotesButton.vue?vue&type=script&lang=js"
import style0 from "./TableNotesButton.vue?vue&type=style&index=0&id=79913a76&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79913a76",
  null
  
)

export default component.exports